import { Button, FormSectionGroup, Layout } from '@vwfs-bronson/bronson-react';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BankDetailsNew } from '../../../../components/BankDetailsNew';
import { FinancialDetailsForm } from '../../../../components/FinancialDetailsForm/FinancialDetailsForm';
import { journeyDataSelectors } from '../../../../services/redux/features/journeyData.slice';
import { useFormSectionHelpers } from '../../../utils';

const getCustomerFormsToRender = (showBankDetails: boolean, isAnotherHirerAdded: boolean) => {
  return [
    'customerDetails1',
    'customerAddress1',
    'employmentDetails1',
    'financialDetails1',
    'linkedRelationship1',
    ...(showBankDetails ? (['bankDetails'] as const) : []),
    ...(isAnotherHirerAdded
      ? ([
          'customerDetails2',
          'customerAddress2',
          'employmentDetails2',
          'financialDetails2',
          'linkedRelationship2',
        ] as const)
      : []),
  ] as const;
};

type FormId = ReturnType<typeof getCustomerFormsToRender>[number];

export const CustomerDataPrivate = () => {
  const [forms, setForms] = useState<ReadonlyArray<FormId>>(() => getCustomerFormsToRender(false, false));
  const [isAnotherHirerAdded, setIsAnotherHirerAdded] = useState(false);

  // When in Standalone Service Plan user selected Upfront payment for service plan,
  // then we do not need Bank Details
  const isUpfrontPayment = useSelector(journeyDataSelectors.isUpfrontPayment);

  const toggleAnotherHirer = () => {
    setIsAnotherHirerAdded((prev) => !prev);
  };

  useEffect(() => {
    setForms([...getCustomerFormsToRender(!isUpfrontPayment, isAnotherHirerAdded)]);
  }, [isUpfrontPayment, isAnotherHirerAdded]);

  const _getFormHelpers = useFormSectionHelpers(forms);

  return (
    <FormSectionGroup>
      {/* customerDetails1 */}
      {/* <CustomerDetailsForm isMainApplicant /> Will be replaced with CustomerDetailsNew in case it's needed */}

      {/* customerAddress1 */}
      {/* <AddressWithPreviousForm isMainApplicant /> Will be replaced in case it's needed  */}

      {/* employmentDetails1 */}
      {/* <EmploymentDetailsFormWithPreviousForm isMainApplicant />  Will be replaced in case it's needed */}

      <FinancialDetailsForm isMainApplicant />

      {/* linkedRelationship1 */}
      {/* <LinkedRelationshipsForm isMainApplicant /> Will be replaced with LinkedRelationshipNew in case it's needed */}

      {!isUpfrontPayment && (
        <BankDetailsNew.FP
          formHelpers={_getFormHelpers('bankDetails')}
          titleTranslationKey='titleTranslationKey="bankDetailsForm:title:business'
        />
      )}

      {isAnotherHirerAdded && (
        <>
          {/* customerDetails2 */}
          {/* <CustomerDetailsForm isMainApplicant /> Will be replaced with CustomerDetailsNew in case it's needed */}

          {/* customerAddress2 */}
          {/* <AddressWithPreviousForm  /> Will be replaced in case it's needed  */}

          {/* employmentDetails2 */}
          {/* <EmploymentDetailsFormWithPreviousForm isMainApplicant={false} />  Will be replaced in case it's needed */}

          <FinancialDetailsForm isMainApplicant={false} />

          {/* linkedRelationship2 */}
          {/* <LinkedRelationshipsForm isMainApplicant /> Will be replaced with LinkedRelationshipNew in case it's needed */}
        </>
      )}

      <Layout className="u-mb">
        <Layout.Item>
          <Button
            icon={isAnotherHirerAdded ? 'semantic-minus' : 'semantic-plus'}
            link
            secondary
            onClick={toggleAnotherHirer}
          >
            {isAnotherHirerAdded
              ? t('customerDataPrivate:removeAnotherHirerButton')
              : t('customerDataPrivate:addAnotherHirerButton')}
          </Button>
        </Layout.Item>
      </Layout>
    </FormSectionGroup>
  );
};
